<footer
  class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">Copyright &copy; 2025 | สำนักงานกำลังพล สำนักงานตำรวจแห่งชาติ</p>
</footer>